(() => {
  'use strict';
  if (window.__ossJerseyRound8FixesInstalled) return;
  window.__ossJerseyRound8FixesInstalled = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const clean = (value) => String(value == null ? '' : value).trim();
  const same = (a, b) => clean(a).toLowerCase() === clean(b).toLowerCase();
  const parseJson = (node) => {
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (_) { return {}; }
  };

  const config = parseJson(qs('[data-oss-product-config]'));
  const product = parseJson(qs('[data-product-json]'));
  const tags = Array.isArray(config.tags) ? config.tags.map((tag) => clean(tag).toLowerCase()) : [];
  const type = clean(config.type || product.type).toLowerCase();
  const isJersey = type.includes('jersey') || tags.some((tag) => tag.includes('jersey'));
  if (!isJersey) return;

  const sizeSource = () => qsa('.option-selector[data-option]').find((element) => {
    const name = clean(element.dataset.option).toLowerCase();
    return ['size', 'größe', 'groesse', 'talla'].includes(name);
  }) || null;

  const sizeNodes = (source = sizeSource()) => {
    if (!source) return [];
    const dropdown = qsa('.custom-select__option[data-value]', source).filter((node) => clean(node.dataset.value));
    if (dropdown.length) return dropdown;
    return qsa('input.opt-btn, input[type="radio"], input.js-option', source).filter((node) => clean(node.value));
  };

  const nodeValue = (node) => clean(node && (node.dataset && node.dataset.value ? node.dataset.value : node.value || node.textContent));
  const nodeSelected = (node) => {
    if (!node) return false;
    if (node.matches && node.matches('input')) return !!node.checked;
    return node.getAttribute('aria-selected') === 'true' || node.classList.contains('selected') || node.classList.contains('is-selected');
  };
  const nodeUnavailable = (node) => !node || !!node.disabled || node.getAttribute('aria-disabled') === 'true' || node.classList.contains('is-unavailable') || node.classList.contains('opt-unavailable') || node.classList.contains('unavailable');

  const selectedSize = () => {
    const selected = sizeNodes().find(nodeSelected);
    return selected ? nodeValue(selected) : '';
  };

  const productForm = () => qs('button[data-add-to-cart]')?.closest('form') || qs('form[action*="/cart/add"]');
  const variantInput = () => {
    const form = productForm();
    return form ? qs('input[name="id"]', form) : null;
  };

  let lockedSize = selectedSize();
  let lockedVariantId = clean(variantInput()?.value);
  let restoring = false;
  let restoreTimer = null;
  let captureTimer = null;

  const syncVisibleButtons = () => {
    if (!lockedSize) return;
    qsa('.oss-size-btn[data-oss-r3-size]').forEach((button) => {
      const active = same(button.dataset.ossR3Size, lockedSize);
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const captureVariant = () => {
    if (!lockedSize || !same(selectedSize(), lockedSize)) return;
    const input = variantInput();
    if (input && clean(input.value)) lockedVariantId = clean(input.value);
    syncVisibleButtons();
  };

  const scheduleVariantCapture = () => {
    window.clearTimeout(captureTimer);
    captureTimer = window.setTimeout(captureVariant, 70);
    window.setTimeout(captureVariant, 180);
    window.setTimeout(captureVariant, 360);
  };

  const activateUnderlyingSize = (value) => {
    const source = sizeSource();
    const node = sizeNodes(source).find((candidate) => same(nodeValue(candidate), value));
    if (!source || !node || nodeUnavailable(node)) return false;

    restoring = true;
    if (node.matches && node.matches('input')) {
      const label = node.id ? qs(`label[for="${CSS.escape(node.id)}"]`, source) : null;
      if (label) label.click();
      else node.click();
    } else {
      node.click();
    }
    window.setTimeout(() => { restoring = false; }, 100);
    return true;
  };

  const restoreSize = () => {
    if (!lockedSize || restoring) return;
    const currentSize = selectedSize();
    const input = variantInput();
    const currentVariantId = clean(input?.value);
    const sizeChanged = !same(currentSize, lockedSize);
    const variantChanged = !!lockedVariantId && !!currentVariantId && currentVariantId !== lockedVariantId;

    if (sizeChanged || variantChanged) {
      if (activateUnderlyingSize(lockedSize)) scheduleVariantCapture();
    }
    syncVisibleButtons();
  };

  const scheduleRestore = () => {
    window.clearTimeout(restoreTimer);
    restoreTimer = window.setTimeout(restoreSize, 20);
    window.setTimeout(restoreSize, 90);
    window.setTimeout(restoreSize, 220);
    window.setTimeout(restoreSize, 420);
  };

  const lockFromButton = (button) => {
    if (!button || button.disabled) return;
    const value = clean(button.dataset.ossR3Size);
    if (!value) return;
    lockedSize = value;
    lockedVariantId = '';
    syncVisibleButtons();
    scheduleVariantCapture();
  };

  window.addEventListener('pointerdown', (event) => {
    const button = event.target && event.target.closest ? event.target.closest('.oss-size-btn[data-oss-r3-size]') : null;
    if (button) lockFromButton(button);
  }, true);

  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = event.target && event.target.closest ? event.target.closest('.oss-size-btn[data-oss-r3-size]') : null;
    if (button) lockFromButton(button);
  }, true);

  document.addEventListener('change', (event) => {
    const source = sizeSource();
    if (source && source.contains(event.target)) {
      if (!lockedSize) lockedSize = selectedSize();
      scheduleVariantCapture();
      return;
    }
    scheduleRestore();
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest ? event.target.closest('.oss-size-btn[data-oss-r3-size]') : null;
    if (!button) scheduleRestore();
  }, true);

  const init = () => {
    lockedSize = selectedSize() || lockedSize;
    lockedVariantId = clean(variantInput()?.value) || lockedVariantId;
    syncVisibleButtons();

    const root = qs('.product-detail__detail') || qs('.product-detail') || document.body;
    new MutationObserver(() => scheduleRestore()).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['checked', 'aria-selected', 'class', 'value', 'disabled', 'aria-disabled']
    });

    window.setTimeout(() => {
      lockedSize = selectedSize() || lockedSize;
      captureVariant();
      syncVisibleButtons();
    }, 250);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
